export const ReleasedList = [
    {
      img: "/illusionlabs/tgx.jpg",
      title: "Touchgrind BMX3",
      description:
        "An live-services cross-platform slope-style mobile game, released on both IOS and Android.",
      tech_stack: ["C#", "Firebase", "Javascript" ,"NodeJS", "VueJS", "Google Analytics", "Google Cloud Platform" ],
      contribution: "Developed our Backend with an additional dashboard. Worked on UI and Tools",
      github_url: "",
      app_store: "https://apps.apple.com/ph/app/touchgrind-x/id6449250454",
      google_play: "https://play.google.com/store/apps/details?id=se.illusionlabs.tgx&hl=sv&pli=1",
      tailer_url: "https://www.youtube.com/watch?v=Bgjt_NfhbPk"
    },
    {
      img: "/illusionlabs/turtle.png",
      title: "Way of the Turtle",
      description:
        "An epic Turtle adventure on Apple Arcade. Available on both AppleTV, Mac, and iOS.",
      contribution: "Added Customizables and worked on UI and debug tools",
      tech_stack: ["C++", "Objective-C"],
      github_url: "",
      app_store: "https://apps.apple.com/us/app/way-of-the-turtle/id1472186054?ign-itscg=30800&ign-itsct=wayoftheturtle",
      google_play: "",
      tailer_url: "https://www.youtube.com/watch?v=F3ei0Qx0KnA"
    },
    {
      img: "/illusionlabs/bmxv2.jpg",
      title: "Touchgrind BMX2",
      description:
        "A Extreme Sports mobile game, available on both iOS and Android.",
      tech_stack: ["C++", "Firebase", "Google Analytics", "ProtoBuf"],
      github_url: "",
      contribution: "Worked on UI and Analytics.",
      app_store: "https://apps.apple.com/us/app/touchgrind-bmx-2/id1313179105",
      google_play: "https://play.google.com/store/apps/details?id=se.illusionlabs.touchgrindbmx2&hl=us",
      tailer_url: "https://www.youtube.com/watch?v=5fKSqonRlSA"
    },
    {
      img: "/illusionlabs/illusionlabs.png",
      title: "Splinter - discontinued",
      description:
        "Online fighting game",
      contribution: "Worked on GamePlay, UI, Tools and Core Systems",
      tech_stack: [ "C++" ],
    },
    {
      img: "/illusionlabs/illusionlabs.png",
      title: "Katastrof - discontinued",
      description:
        "Couch Co-up puzzle game",
      contribution: "Worked on GamePlay, UI, Tools and Core Systems",
      tech_stack: [ "C#", "Unity" ],
    },
  ];
  
  // --------------------------------------- Skills
  
  export const stackList = [
    {
      img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/apple/apple-original.svg",
      name: "Apple",
    },
    {
      img: "https://github.com/devicons/devicon/blob/master/icons/android/android-original.svg",
      name: "Android"
    },
    {
      img: "https://github.com/devicons/devicon/blob/master/icons/cplusplus/cplusplus-original.svg",
      name: "C++"
    },
    {
      img: "https://github.com/devicons/devicon/blob/master/icons/csharp/csharp-original.svg",
      name: "C#"
    },
  
  
  
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    //   name: "HTML",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    //   name: "CSS",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    //   name: "JavaScript",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    //   name: "ReactJS",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg",
    //   name: "NextJs",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    //   name: "Typescript",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    //   name: "Git",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    //   name: "React Native",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    //   name: "NodeJS",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/firebase/firebase-plain.svg",
    //   name: "Firebase",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    //   name: "MongoDB",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    //   name: "Python",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original.svg",
    //   name: "Flask",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
    //   name: "C",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    //   name: "Java",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    //   name: "MySQL",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
    //   name: "Bootstrap",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
    //   name: "Material UI",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
    //   name: "Figma",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/tailwindcss/tailwindcss-plain.svg",
    //   name: "TailwindCSS",
    // },
    // {
    //   img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    //   name: "VS Code",
    // },
  ];
  